import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  outerContainer: {
    position: 'relative',
    height: 0,
    overflow: 'visible',
    pointerEvents: 'none'
  },
  innerContainer: {
    position: 'absolute',
    left: '-9999px',
    top: 0,
    width: props => (props.fullWidth ? '100%' : 'max-content')
  }
})

export default useStyles
